module.exports = __webpack_public_path__ + "img/3.ef48f946.jpg";